import { render, staticRenderFns } from "./closing.vue?vue&type=template&id=6416621c&scoped=true"
import script from "./closing.vue?vue&type=script&lang=js"
export * from "./closing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416621c",
  null
  
)

export default component.exports